/* eslint-disable indent */ import { createPreset } from "@bbob/preset";
import defaultTags from "./defaultTags";
export default createPreset(defaultTags);
